(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coco-coir-bricks-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var root=document.getElementById('ccb-wrap');
  if(!root)return;

  var mainImg=document.getElementById('ccb-main-image');
  root.querySelectorAll('.ccb-thumb').forEach(function(btn){
    btn.addEventListener('click',function(){
      root.querySelectorAll('.ccb-thumb').forEach(function(x){x.classList.remove('ccb-active');});
      btn.classList.add('ccb-active');
      if(mainImg && btn.dataset.src)mainImg.src=btn.dataset.src;
    });
  });

  function fmt(cents){
    var currency=root.getAttribute('data-currency')||'USD';
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format((Number(cents)||0)/100);}
    catch(e){return '$'+((Number(cents)||0)/100).toFixed(2);}
  }

  var idInput=document.getElementById('ccb-variant-id');
  var qtyInput=document.getElementById('ccb-qty');
  var priceEl=document.getElementById('ccb-price');
  var compareEl=document.getElementById('ccb-compare');
  var saveEl=document.getElementById('ccb-save');
  var totalEl=document.getElementById('ccb-total');
  var stickyPrice=document.getElementById('ccb-sticky-price');
  var atc=document.getElementById('ccb-atc');
  var selectedPrice=Number(root.querySelector('.ccb-vbtn.ccb-selected')?.dataset.price||0);

  function updateTotal(){
    var qty=Math.max(1,parseInt(qtyInput?.value||'1',10)||1);
    if(qtyInput)qtyInput.value=qty;
    var total=selectedPrice*qty;
    if(totalEl)totalEl.textContent=fmt(total);
    if(stickyPrice)stickyPrice.textContent=fmt(selectedPrice);
  }

  root.querySelectorAll('.ccb-vbtn').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(btn.disabled)return;
      root.querySelectorAll('.ccb-vbtn').forEach(function(x){x.classList.remove('ccb-selected');});
      btn.classList.add('ccb-selected');
      var p=Number(btn.dataset.price||0);
      var c=Number(btn.dataset.compare||0);
      var available=String(btn.dataset.available)==='true';
      selectedPrice=p;
      if(idInput)idInput.value=btn.dataset.id;
      if(priceEl)priceEl.textContent=fmt(p);
      if(compareEl)compareEl.textContent=c>p?fmt(c):'';
      if(saveEl){
        if(c>p){
          var pct=Math.round((1-p/c)*100);
          saveEl.textContent='SAVE '+pct+'%';
          saveEl.classList.add('ccb-show');
        }else{
          saveEl.textContent='SAVE';
          saveEl.classList.remove('ccb-show');
        }
      }
      if(atc){
        atc.disabled=!available;
        atc.innerHTML=available?'ADD TO CART · <span id="ccb-total">'+fmt(p*Math.max(1,parseInt(qtyInput?.value||'1',10)||1))+'</span>':'SOLD OUT';
        totalEl=document.getElementById('ccb-total');
      }
      updateTotal();
    });
  });

  document.getElementById('ccb-minus')?.addEventListener('click',function(){
    if(!qtyInput)return;
    qtyInput.value=Math.max(1,(parseInt(qtyInput.value||'1',10)||1)-1);
    updateTotal();
  });
  document.getElementById('ccb-plus')?.addEventListener('click',function(){
    if(!qtyInput)return;
    qtyInput.value=Math.max(1,(parseInt(qtyInput.value||'1',10)||1)+1);
    updateTotal();
  });
  qtyInput?.addEventListener('input',updateTotal);

  root.querySelectorAll('.ccb-accq').forEach(function(q){
    q.addEventListener('click',function(){
      var item=q.closest('.ccb-accitem');
      item.classList.toggle('ccb-open');
      q.querySelector('span').textContent=item.classList.contains('ccb-open')?'−':'+';
    });
  });

  root.querySelectorAll('.ccb-fq').forEach(function(q){
    q.addEventListener('click',function(){
      var item=q.closest('.ccb-fitem');
      item.classList.toggle('ccb-open');
      q.querySelector('.ccb-plus').textContent=item.classList.contains('ccb-open')?'−':'+';
    });
  });

  document.getElementById('ccb-final-btn')?.addEventListener('click',function(){
    root.querySelector('.ccb-info')?.scrollIntoView({behavior:'smooth',block:'start'});
  });
  document.getElementById('ccb-sticky-btn')?.addEventListener('click',function(){
    if(atc && !atc.disabled)atc.click();
  });

  updateTotal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["einlive-silk-body-oil"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('esbo-wrap');
  if(!root)return;
  root.querySelectorAll('.esbo-faqitem').forEach(function(item){
    var btn=item.querySelector('.esbo-faqbtn');
    if(!btn)return;
    btn.addEventListener('click',function(){
      var open=item.classList.toggle('esbo-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galactic-garden-fb"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('gsl2-wrap');
  if(!root)return;

  var main=root.querySelector('.gsl2-main-img');
  root.querySelectorAll('[data-gsl2-src]').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(main)main.src=btn.getAttribute('data-gsl2-src');
      root.querySelectorAll('.gsl2-thumb').forEach(function(x){x.classList.remove('gsl2-on');});
      btn.classList.add('gsl2-on');
    });
  });

  var moneyNode=root.querySelector('[data-gsl2-money]');
  var moneyFormat='${{amount}}';
  if(moneyNode){try{moneyFormat=JSON.parse(moneyNode.textContent||'"${{amount}}"');}catch(e){}}
  function money(cents){
    var v=(Number(cents||0)/100).toFixed(2);
    return String(moneyFormat)
      .replace(/\{\{\s*amount\s*\}\}/g,v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,String(Math.round(Number(cents||0)/100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,v.replace('.',','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,String(Math.round(Number(cents||0)/100)));
  }

  var id=root.querySelector('[data-gsl2-id]');
  var priceWrap=root.querySelector('.gsl2-price');
  var price=root.querySelector('[data-gsl2-price]');
  var compare=root.querySelector('[data-gsl2-compare]');
  var saveBadge=root.querySelector('[data-gsl2-save]');
  var stickyPrice=root.querySelector('[data-gsl2-sticky-price]');
  var atc=root.querySelector('[data-gsl2-atc]');
  var buy=root.querySelector('[data-gsl2-buy]');
  var qty=root.querySelector('[data-gsl2-qty]');
  var minus=root.querySelector('[data-gsl2-minus]');
  var plus=root.querySelector('[data-gsl2-plus]');

  var unitPrice=priceWrap ? Number(priceWrap.getAttribute('data-gsl2-unit-price')||0) : 0;
  var unitCompare=priceWrap ? Number(priceWrap.getAttribute('data-gsl2-unit-compare')||0) : 0;

  function getQty(){
    if(!qty)return 1;
    var q=parseInt(qty.value,10);
    if(!q || q<1)q=1;
    qty.value=q;
    return q;
  }

  function updateDisplayedTotal(){
    var q=getQty();
    var total=unitPrice*q;
    var compareTotal=unitCompare*q;

    if(price)price.textContent=money(total);
    if(stickyPrice)stickyPrice.textContent=money(total);

    if(compare){
      if(unitCompare>unitPrice && unitCompare>0){
        compare.hidden=false;
        compare.textContent=money(compareTotal);
      }else{
        compare.hidden=true;
      }
    }

    if(saveBadge){
      if(unitCompare>unitPrice && unitCompare>0){
        var pct=Math.round(((unitCompare-unitPrice)/unitCompare)*100);
        saveBadge.hidden=false;
        saveBadge.textContent='Save '+pct+'%';
      }else{
        saveBadge.hidden=true;
      }
    }
  }

  root.querySelectorAll('[data-gsl2-variant]').forEach(function(btn){
    btn.addEventListener('click',function(){
      root.querySelectorAll('[data-gsl2-variant]').forEach(function(x){x.classList.remove('gsl2-selected');});
      btn.classList.add('gsl2-selected');

      var vid=btn.getAttribute('data-gsl2-variant');
      unitPrice=Number(btn.getAttribute('data-gsl2-price-cents')||0);
      unitCompare=Number(btn.getAttribute('data-gsl2-compare-cents')||0);
      var ok=btn.getAttribute('data-gsl2-available')==='true';

      if(id)id.value=vid;
      if(priceWrap){
        priceWrap.setAttribute('data-gsl2-unit-price',String(unitPrice));
        priceWrap.setAttribute('data-gsl2-unit-compare',String(unitCompare));
      }

      updateDisplayedTotal();

      if(atc)atc.disabled=!ok;
      if(buy)buy.disabled=!ok;
    });
  });

  if(qty&&minus&&plus){
    minus.addEventListener('click',function(){
      qty.value=Math.max(1,getQty()-1);
      updateDisplayedTotal();
    });

    plus.addEventListener('click',function(){
      qty.value=getQty()+1;
      updateDisplayedTotal();
    });

    qty.addEventListener('input',function(){
      updateDisplayedTotal();
    });

    qty.addEventListener('change',function(){
      updateDisplayedTotal();
    });
  }

  updateDisplayedTotal();

  var form=root.querySelector('#gsl2-form');
  if(buy&&form){
    buy.addEventListener('click',function(){
      if(buy.disabled)return;
      buy.disabled=true;
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
        .then(function(){window.location.href='/checkout';})
        .catch(function(){buy.disabled=false;form.submit();});
    });
  }

  root.querySelectorAll('.gsl2-faq-item').forEach(function(item){
    item.addEventListener('click',function(){item.classList.toggle('gsl2-open');});
  });

  var sticky=root.querySelector('[data-gsl2-sticky]');
  if(sticky&&atc){
    sticky.addEventListener('click',function(){
      root.scrollIntoView({behavior:'smooth',block:'start'});
      setTimeout(function(){atc.focus();},450);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itoolmax-weed-cutter"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('itmwc-ROOT');
  if(!root)return;
  var main=root.querySelector('#iw-mainimg-{{ section.id }}');
  var thumbs=root.querySelectorAll('.iw-th');
  thumbs.forEach(function(btn){
    btn.addEventListener('click',function(){
      thumbs.forEach(function(x){x.classList.remove('act')});
      btn.classList.add('act');
      if(main){main.setAttribute('src',btn.getAttribute('data-src'))}
    });
  });
  root.querySelectorAll('form').forEach(function(form){
    var input=form.querySelector('[data-qty]');
    var dec=form.querySelector('[data-dec]');
    var inc=form.querySelector('[data-inc]');
    if(dec&&input){dec.addEventListener('click',function(){var v=parseInt(input.value||'1',10);input.value=Math.max(1,v-1);});}
    if(inc&&input){inc.addEventListener('click',function(){var v=parseInt(input.value||'1',10);input.value=Math.max(1,v+1);});}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manta-ray-automaton-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.mra2Ready==='1')return;
    root.dataset.mra2Ready='1';

    var main=root.querySelector('[data-mra2-main]');
    root.querySelectorAll('[data-mra2-src]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(main)main.src=btn.getAttribute('data-mra2-src');
        root.querySelectorAll('[data-mra2-src]').forEach(function(x){x.classList.remove('mra2-active')});
        btn.classList.add('mra2-active');
      });
    });

    var qty=root.querySelector('[data-mra2-qty]');
    var price=root.querySelector('[data-mra2-price]');
    var compare=root.querySelector('[data-mra2-compare]');
    var save=root.querySelector('[data-mra2-save]');
    var atc=root.querySelector('[data-mra2-atc]');
    var atcPrice=root.querySelector('[data-mra2-atc-price]');
    var stickyPrice=root.querySelector('[data-mra2-sticky-price]');
    var variantInput=root.querySelector('[data-mra2-variant-id]');
    var variantsNode=root.querySelector('[data-mra2-variants]');
    var variants=variantsNode?JSON.parse(variantsNode.textContent):[];
    var currencyNode=root.querySelector('[data-mra2-currency]');
    var currency=currencyNode?currencyNode.getAttribute('data-code'):'USD';

    var unitPrice=parseInt(price?price.getAttribute('data-unit-price'):'0',10)||0;
    var unitCompare=parseInt(compare?compare.getAttribute('data-unit-compare'):'0',10)||0;

    function money(cents){
      try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(cents/100)}
      catch(e){return '$'+(cents/100).toFixed(2)}
    }
    function getQty(){
      var n=parseInt(qty&&qty.value?qty.value:'1',10);
      if(!n||n<1)n=1;
      if(qty)qty.value=n;
      return n;
    }
    function updateTotal(){
      var n=getQty();
      var total=unitPrice*n;
      var compTotal=unitCompare*n;
      if(price)price.textContent=money(total);
      if(atcPrice)atcPrice.textContent=money(total);
      if(stickyPrice)stickyPrice.textContent=money(total);
      if(compare){
        if(unitCompare>unitPrice){compare.style.display='';compare.textContent=money(compTotal)}
        else{compare.style.display='none'}
      }
      if(save){
        if(unitCompare>unitPrice){
          save.style.display='';
          save.textContent='SAVE '+Math.round((unitCompare-unitPrice)*100/unitCompare)+'%';
        }else{save.style.display='none'}
      }
    }

    var minus=root.querySelector('[data-mra2-minus]');
    var plus=root.querySelector('[data-mra2-plus]');
    if(minus)minus.addEventListener('click',function(){if(qty)qty.value=Math.max(1,getQty()-1);updateTotal()});
    if(plus)plus.addEventListener('click',function(){if(qty)qty.value=getQty()+1;updateTotal()});
    if(qty){qty.addEventListener('input',updateTotal);qty.addEventListener('change',updateTotal)}

    function chosen(){
      var vals=[];
      root.querySelectorAll('[data-mra2-option-group]').forEach(function(group){
        var checked=group.querySelector('input[type="radio"]:checked');
        vals.push(checked?checked.value:'');
      });
      return vals;
    }

    function syncVariant(){
      var selected=chosen();
      var match=variants.find(function(v){
        return selected.every(function(val,index){return v.options[index]===val});
      });
      if(!match)return;

      if(variantInput)variantInput.value=match.id;
      unitPrice=parseInt(match.price||0,10)||0;
      unitCompare=parseInt(match.compare_at_price||0,10)||0;
      if(price)price.setAttribute('data-unit-price',unitPrice);
      if(compare)compare.setAttribute('data-unit-compare',unitCompare);

      if(atc){
        atc.disabled=!match.available;
        if(match.available){
          atc.innerHTML='ADD TO CART · <span data-mra2-atc-price>'+money(unitPrice*getQty())+'</span>';
          atcPrice=atc.querySelector('[data-mra2-atc-price]');
        }else{
          atc.textContent='SOLD OUT';
          atcPrice=null;
        }
      }
      updateTotal();
    }

    root.querySelectorAll('[data-mra2-option-group] input').forEach(function(inp){inp.addEventListener('change',syncVariant)});

    root.querySelectorAll('.mra2-faq-q').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest('.mra2-faq-item');
        if(item)item.classList.toggle('mra2-open');
      });
    });

    var sticky=root.querySelector('[data-mra2-sticky-add]');
    if(sticky){
      sticky.addEventListener('click',function(){
        var form=root.querySelector('form[action*="/cart/add"]');
        if(form){
          if(form.requestSubmit)form.requestSubmit();
          else form.submit();
        }
      });
    }

    updateTotal();
  }

  document.querySelectorAll('[data-mra2-root]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){
    e.target.querySelectorAll('[data-mra2-root]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvyla-chandelier-cleaner"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('ovc-wrap');
  if(!root)return;

  root.querySelectorAll('.ovc-faq-item').forEach(function(item){
    item.addEventListener('click',function(){ item.classList.toggle('ovc-open'); });
  });

  var track=root.querySelector('.ovc-compat');
  var left=root.querySelector('.ovc-arr-l');
  var right=root.querySelector('.ovc-arr-r');
  if(track&&left&&right){
    left.addEventListener('click',function(){track.scrollBy({left:-Math.max(280,track.clientWidth*.7),behavior:'smooth'});});
    right.addEventListener('click',function(){track.scrollBy({left:Math.max(280,track.clientWidth*.7),behavior:'smooth'});});
  }

  var q=root.querySelector('[data-qinput]');
  var qm=root.querySelector('[data-qminus]');
  var qp=root.querySelector('[data-qplus]');
  if(q&&qm&&qp){
    qm.addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value,10)||1)-1);});
    qp.addEventListener('click',function(){q.value=(parseInt(q.value,10)||1)+1;});
  }

  var buy=root.querySelector('[data-buy-now]');
  var form=root.querySelector('#ovc-product-form');
  if(buy&&form){
    buy.addEventListener('click',function(){
      buy.disabled=true;
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('Cart error');return r.json();})
        .then(function(){window.location.href='/checkout';})
        .catch(function(){buy.disabled=false;form.submit();});
    });
  }

  var timer=root.querySelector('[data-ovc-timer]');
  if(timer){
    var key='ovc_offer_end';
    var end=parseInt(sessionStorage.getItem(key)||'0',10);
    if(!end||end<Date.now()){end=Date.now()+(12*60*60+9*60+9)*1000;sessionStorage.setItem(key,String(end));}
    var h=timer.querySelector('[data-h]'),m=timer.querySelector('[data-m]'),s=timer.querySelector('[data-s]');
    function tick(){
      var diff=Math.max(0,end-Date.now());
      var sec=Math.floor(diff/1000);
      var hh=Math.floor(sec/3600),mm=Math.floor((sec%3600)/60),ss=sec%60;
      h.textContent=String(hh).padStart(2,'0');
      m.textContent=String(mm).padStart(2,'0');
      s.textContent=String(ss).padStart(2,'0');
      if(diff<=0){end=Date.now()+(12*60*60+9*60+9)*1000;sessionStorage.setItem(key,String(end));}
    }
    tick();setInterval(tick,1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outdoor-cleaner-landing"] && !Shopify.designMode) return;
  try {
    
(function(){var root=document.getElementById('moc-wrap');if(!root)return;var form=root.querySelector('#moc-product-form'),sel=root.querySelector('#moc-variant'),img=root.querySelector('#moc-main-image'),price=root.querySelector('[data-moc-price]'),compare=root.querySelector('[data-moc-compare]'),save=root.querySelector('[data-moc-save]'),add=root.querySelector('[data-moc-add]'),buy=root.querySelector('[data-moc-buy]'),err=root.querySelector('[data-moc-error]');if(!form||!sel)return;var variants=Array.prototype.slice.call(sel.options),options=Array.prototype.slice.call(root.querySelectorAll('[data-moc-variant]')),thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-moc-image]'));function setImage(src,media){if(src&&img)img.src=src;thumbs.forEach(function(t){t.classList.toggle('moc-active',media&&t.dataset.mocMedia===media)})}function update(o){sel.value=o.value;var pr=parseInt(o.dataset.priceRaw||0,10),cr=parseInt(o.dataset.compareRaw||0,10),available=o.dataset.available==='true';price.textContent=o.dataset.price||'';if(compare){compare.textContent=o.dataset.compare||'';compare.hidden=!(cr>pr)}if(save){save.textContent=cr>pr?'SAVE '+Math.round((cr-pr)*100/cr)+'%':'';save.hidden=!(cr>pr)}setImage(o.dataset.image,o.dataset.media);add.disabled=!available;buy.disabled=!available;add.textContent=available?'ADD TO CART':'SOLD OUT';err.classList.toggle('moc-show',!available);options.forEach(function(b){b.classList.toggle('moc-selected',b.dataset.mocVariant===o.value)});if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u.toString())}}options.forEach(function(b){b.addEventListener('click',function(){var o=variants.find(function(v){return v.value===b.dataset.mocVariant});if(o)update(o)})});thumbs.forEach(function(t){t.addEventListener('click',function(){setImage(t.dataset.mocImage,t.dataset.mocMedia)})});if(buy)buy.addEventListener('click',function(){buy.disabled=true;fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}).then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(){location.href='/checkout'}).catch(function(){buy.disabled=false;form.requestSubmit()})});update(sel.options[sel.selectedIndex])})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozzy-halloween-osbourne-moments-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.hwcReady==='1')return;
    root.dataset.hwcReady='1';
    var main=root.querySelector('[data-hwc-main]');
    root.querySelectorAll('[data-hwc-src]').forEach(function(btn){btn.addEventListener('click',function(){if(main)main.src=btn.getAttribute('data-hwc-src');root.querySelectorAll('[data-hwc-src]').forEach(function(x){x.classList.remove('hwc-active')});btn.classList.add('hwc-active')})});
    var qty=root.querySelector('[data-hwc-qty]'),price=root.querySelector('[data-hwc-price]'),compare=root.querySelector('[data-hwc-compare]'),save=root.querySelector('[data-hwc-save]'),atc=root.querySelector('[data-hwc-atc]'),atcPrice=root.querySelector('[data-hwc-atc-price]'),stickyPrice=root.querySelector('[data-hwc-sticky-price]'),variantInput=root.querySelector('[data-hwc-variant-id]');
    var variantsNode=root.querySelector('[data-hwc-variants]'),variants=variantsNode?JSON.parse(variantsNode.textContent):[],currencyNode=root.querySelector('[data-hwc-currency]'),currency=currencyNode?currencyNode.getAttribute('data-code'):'USD';
    var unitPrice=parseInt(price?price.getAttribute('data-unit-price'):'0',10)||0,unitCompare=parseInt(compare?compare.getAttribute('data-unit-compare'):'0',10)||0;
    function money(c){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}}
    function getQty(){var n=parseInt(qty&&qty.value?qty.value:'1',10);if(!n||n<1)n=1;if(qty)qty.value=n;return n}
    function updateTotal(){var n=getQty(),t=unitPrice*n,ct=unitCompare*n;if(price)price.textContent=money(t);if(atcPrice)atcPrice.textContent=money(t);if(stickyPrice)stickyPrice.textContent=money(t);if(compare){if(unitCompare>unitPrice){compare.style.display='';compare.textContent=money(ct)}else compare.style.display='none'}if(save){if(unitCompare>unitPrice){save.style.display='';save.textContent='SAVE '+Math.round((unitCompare-unitPrice)*100/unitCompare)+'%'}else save.style.display='none'}}
    var minus=root.querySelector('[data-hwc-minus]'),plus=root.querySelector('[data-hwc-plus]');
    if(minus)minus.addEventListener('click',function(){if(qty)qty.value=Math.max(1,getQty()-1);updateTotal()});
    if(plus)plus.addEventListener('click',function(){if(qty)qty.value=getQty()+1;updateTotal()});
    if(qty){qty.addEventListener('input',updateTotal);qty.addEventListener('change',updateTotal)}
    root.querySelectorAll('[data-hwc-bundle]').forEach(function(btn){btn.addEventListener('click',function(){root.querySelectorAll('[data-hwc-bundle]').forEach(function(x){x.classList.remove('hwc-selected')});btn.classList.add('hwc-selected');if(qty)qty.value=parseInt(btn.getAttribute('data-hwc-bundle')||'1',10);updateTotal()})});
    function chosen(){var vals=[];root.querySelectorAll('[data-hwc-option-group]').forEach(function(g){var c=g.querySelector('input[type="radio"]:checked');vals.push(c?c.value:'')});return vals}
    function syncVariant(){var selected=chosen();var m=variants.find(function(v){return selected.every(function(val,i){return v.options[i]===val})});if(!m)return;if(variantInput)variantInput.value=m.id;unitPrice=parseInt(m.price||0,10)||0;unitCompare=parseInt(m.compare_at_price||0,10)||0;if(price)price.setAttribute('data-unit-price',unitPrice);if(compare)compare.setAttribute('data-unit-compare',unitCompare);if(atc){atc.disabled=!m.available;if(m.available){atc.innerHTML='ADD TO CART · <span data-hwc-atc-price>'+money(unitPrice*getQty())+'</span>';atcPrice=atc.querySelector('[data-hwc-atc-price]')}else{atc.textContent='SOLD OUT';atcPrice=null}}updateTotal()}
    root.querySelectorAll('[data-hwc-option-group] input').forEach(function(inp){inp.addEventListener('change',syncVariant)});
    root.querySelectorAll('.hwc-faq-q').forEach(function(btn){btn.addEventListener('click',function(){var item=btn.closest('.hwc-faq-item');if(item)item.classList.toggle('hwc-open')})});
    var sticky=root.querySelector('[data-hwc-sticky-add]');if(sticky)sticky.addEventListener('click',function(){var form=root.querySelector('form[action*="/cart/add"]');if(form){if(form.requestSubmit)form.requestSubmit();else form.submit()}});
    updateTotal();
  }
  document.querySelectorAll('[data-hwc-root]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-hwc-root]').forEach(init)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewing-studio-v2-fixed"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.sst2Ready==='1')return;
    root.dataset.sst2Ready='1';

    var main=root.querySelector('[data-sst2-main]');
    root.querySelectorAll('[data-sst2-src]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(main)main.src=btn.getAttribute('data-sst2-src');
        root.querySelectorAll('[data-sst2-src]').forEach(function(x){x.classList.remove('sst2-active')});
        btn.classList.add('sst2-active');
      });
    });

    var qty=root.querySelector('[data-sst2-qty]');
    var price=root.querySelector('[data-sst2-price]');
    var compare=root.querySelector('[data-sst2-compare]');
    var save=root.querySelector('[data-sst2-save]');
    var atc=root.querySelector('[data-sst2-atc]');
    var atcPrice=root.querySelector('[data-sst2-atc-price]');
    var stickyPrice=root.querySelector('[data-sst2-sticky-price]');
    var variantInput=root.querySelector('[data-sst2-variant-id]');
    var variantsNode=root.querySelector('[data-sst2-variants]');
    var variants=variantsNode?JSON.parse(variantsNode.textContent):[];
    var currencyNode=root.querySelector('[data-sst2-currency]');
    var currency=currencyNode?currencyNode.getAttribute('data-code'):'USD';

    var unitPrice=parseInt(price?price.getAttribute('data-unit-price'):'0',10)||0;
    var unitCompare=parseInt(compare?compare.getAttribute('data-unit-compare'):'0',10)||0;

    function money(cents){
      try{
        return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(cents/100);
      }catch(e){
        return '$'+(cents/100).toFixed(2);
      }
    }

    function getQty(){
      var n=parseInt(qty&&qty.value?qty.value:'1',10);
      if(!n || n<1)n=1;
      if(qty)qty.value=n;
      return n;
    }

    function updateTotal(){
      var n=getQty();
      var total=unitPrice*n;
      var compareTotal=unitCompare*n;

      if(price)price.textContent=money(total);
      if(atcPrice)atcPrice.textContent=money(total);
      if(stickyPrice)stickyPrice.textContent=money(total);

      if(compare){
        if(unitCompare>unitPrice){
          compare.style.display='';
          compare.textContent=money(compareTotal);
        }else{
          compare.style.display='none';
        }
      }

      if(save){
        if(unitCompare>unitPrice){
          save.style.display='';
          save.textContent='SAVE '+Math.round((unitCompare-unitPrice)*100/unitCompare)+'%';
        }else{
          save.style.display='none';
        }
      }
    }

    var minus=root.querySelector('[data-sst2-minus]');
    var plus=root.querySelector('[data-sst2-plus]');
    if(minus)minus.addEventListener('click',function(){if(qty)qty.value=Math.max(1,getQty()-1);updateTotal()});
    if(plus)plus.addEventListener('click',function(){if(qty)qty.value=getQty()+1;updateTotal()});
    if(qty){
      qty.addEventListener('input',updateTotal);
      qty.addEventListener('change',updateTotal);
    }

    root.querySelectorAll('[data-sst2-bundle]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-sst2-bundle]').forEach(function(x){x.classList.remove('sst2-selected')});
        btn.classList.add('sst2-selected');
        if(qty)qty.value=parseInt(btn.getAttribute('data-sst2-bundle')||'1',10);
        updateTotal();
      });
    });

    function chosen(){
      var vals=[];
      root.querySelectorAll('[data-sst2-option-group]').forEach(function(group){
        var checked=group.querySelector('input[type="radio"]:checked');
        vals.push(checked?checked.value:'');
      });
      return vals;
    }

    function syncVariant(){
      var selected=chosen();
      var match=variants.find(function(v){
        return selected.every(function(val,index){return v.options[index]===val});
      });
      if(!match)return;

      if(variantInput)variantInput.value=match.id;
      unitPrice=parseInt(match.price||0,10)||0;
      unitCompare=parseInt(match.compare_at_price||0,10)||0;

      if(price)price.setAttribute('data-unit-price',unitPrice);
      if(compare)compare.setAttribute('data-unit-compare',unitCompare);

      if(atc){
        atc.disabled=!match.available;
        if(match.available){
          atc.innerHTML='ADD TO CART · <span data-sst2-atc-price>'+money(unitPrice*getQty())+'</span>';
          atcPrice=atc.querySelector('[data-sst2-atc-price]');
        }else{
          atc.textContent='SOLD OUT';
          atcPrice=null;
        }
      }

      updateTotal();
    }

    root.querySelectorAll('[data-sst2-option-group] input').forEach(function(inp){
      inp.addEventListener('change',syncVariant);
    });

    root.querySelectorAll('.sst2-faq-q').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest('.sst2-faq-item');
        if(item)item.classList.toggle('sst2-open');
      });
    });

    var sticky=root.querySelector('[data-sst2-sticky-add]');
    if(sticky){
      sticky.addEventListener('click',function(){
        var form=root.querySelector('form[action*="/cart/add"]');
        if(form){
          if(form.requestSubmit)form.requestSubmit();
          else form.submit();
        }
      });
    }

    updateTotal();
  }

  document.querySelectorAll('[data-sst2-root]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){
    e.target.querySelectorAll('[data-sst2-root]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryourplus-breast-patch"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('tobp-wrap');
  if(!root)return;
  root.querySelectorAll('.tobp-faqitem').forEach(function(item){
    var btn=item.querySelector('.tobp-faqbtn');
    if(!btn)return;
    btn.addEventListener('click',function(){
      var open=item.classList.toggle('tobp-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
  });
  var price=root.querySelector('[data-tobp-price]');
  var compare=root.querySelector('[data-tobp-compare]');
  root.querySelectorAll('input[name="id"][data-tobp-price-value]').forEach(function(input){
    input.addEventListener('change',function(){
      if(price)price.textContent=this.getAttribute('data-tobp-price-value')||'';
      if(compare){
        var c=this.getAttribute('data-tobp-compare-value')||'';
        compare.textContent=c;
        compare.style.display=c?'':'none';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
